<template>
  <div v-if="showModal" :class="$utilModalStyle.modalOverlay" @click="props.bgClickClose ? closeModal() : null">
    <div :class="$utilModalStyle.modalContent" @click.stop>
      <h3 :class="$utilModalStyle.modalTitle">{{ props.title }}</h3>
      <div :class="[$utilModalStyle.modalBody, $style.modalBodyTexts]">
        <div v-if="props.primaryText" :class="$style.primaryText">{{ props.primaryText }}</div>
        <div v-if="props.secondaryText" :class="$style.secondaryText">{{ props.secondaryText }}</div>
      </div>
      <div v-if="props.primaryAction || props.secondaryAction" :class="$utilModalStyle.modalActions">
        <!-- <button  :class="$style.closeButton" @click="closeModal">Close</button> -->
        <button v-if="props.secondaryText" :class="$utilModalStyle.secondaryAction" @click="props.secondaryAction">
          {{ props.secondaryActionText }}
        </button>
        <button v-if="props.primaryAction" :class="$utilModalStyle.primaryAction" @click="props.primaryAction">
          {{ props.primaryActionText }}
        </button>
      </div>
      <div v-if="props.helperText" :class="$utilModalStyle.modalHelperText"><span>{{ $t('note') }}:</span> {{ props.helperText }}</div>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/UtilConfirmationModal.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";

const $style = styles;
const $utilModalStyle = utilModalStyles;

// eslint-disable-next-line
const props = defineProps({
  showModal: {
    type: Boolean,
    required: true,
  },
  closeModal: {
    type: Function,
    required: true,
  },
  title: {
    type: String,
    required: false,
    default: "Are you sure?",
  },
  primaryText: {
    type: String,
    required: false,
    default: "",
  },
  secondaryText: {
    type: String,
    required: false,
    default: "",
  },
  helperText: {
    type: String,
    required: false,
    default: "",
  },
  primaryAction: {
    type: Function,
    required: false,
    default: () => {},
  },
  secondaryAction: {
    type: Function,
    required: false,
    default: () => {},
  },
  primaryActionText: {
    type: String,
    required: false,
    default: "Proceed",
  },
  secondaryActionText: {
    type: String,
    required: false,
    default: "Close",
  },
  bgClickClose: {
    type: Boolean,
    required: false,
    default: true,
  },
});
</script>

<style scoped></style>
